import { render, staticRenderFns } from "./TableMedias.vue?vue&type=template&id=30224a8f&"
import script from "./TableMedias.vue?vue&type=script&lang=js&"
export * from "./TableMedias.vue?vue&type=script&lang=js&"
import style0 from "./TableMedias.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports